<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h1>Get in Touch</h1>
            <p>Tell us about your project &mdash; we'd love to hear from you</p>
        </div>
    </div>
</div>

<section class="contact-area ptb-100">
    <div class="container">
        <div class="contact-inner">
            <div class="contact-info">
                <div class="contact-info-content">
                    <h3>Call or email us and our team will get back to you</h3>
                    <h2>
                        <a href="tel:+94112186555">+94 112 186 555</a>
                        <span>OR</span>
                        <a href="mailto:info&#64;webstazy.one">info&#64;webstazy.one</a>
                    </h2>
                    <ul class="social">
                        <li><a href="https://twitter.com/WebstazyOne" target="_blank" rel="noopener noreferrer"
                                aria-label="Webstazy One on Twitter"><i class="bx bxl-twitter" aria-hidden="true"></i></a></li>
                        <li><a href="https://www.facebook.com/webstazyone" target="_blank" rel="noopener noreferrer"
                                aria-label="Webstazy One on Facebook"><i class='bx bxl-facebook' aria-hidden="true"></i></a></li>
                        <li><a href="https://www.linkedin.com/company/webstazy-one/" target="_blank" rel="noopener noreferrer"
                                aria-label="Webstazy One on LinkedIn"><i class="bx bxl-linkedin" aria-hidden="true"></i></a></li>
                        <li><a href="https://www.instagram.com/webstazy_one/" target="_blank" rel="noopener noreferrer"
                                aria-label="Webstazy One on Instagram"><i class="bx bxl-instagram" aria-hidden="true"></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="row contact-offices">
                <div class="col-md-6">
                    <div class="contact-office">
                        <i class="bx bx-map" aria-hidden="true"></i>
                        <h3>Operations Office</h3>
                        <address>34, Thalawathugoda Road, Pitakotte 10100, Sri Lanka</address>
                        <a href="https://www.google.com/maps/place/Webstazy+One/@6.8840734,79.9030667,15z" target="_blank"
                            rel="noopener noreferrer">Get directions<span class="visually-hidden"> to the Operations Office (opens in a new tab)</span></a>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="contact-office">
                        <i class="bx bx-buildings" aria-hidden="true"></i>
                        <h3>Corporate Office</h3>
                        <address>55/1, Flower Road, Colombo 07 00700, Sri Lanka</address>
                        <a href="https://www.google.com/maps/search/?api=1&amp;query=55%2F1+Flower+Road+Colombo+07+Sri+Lanka"
                            target="_blank" rel="noopener noreferrer">Get directions<span class="visually-hidden"> to the Corporate Office (opens in a new tab)</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="our-loving-clients ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="section-title">
            <h2>Our Loving Clients</h2>
        </div>
        <div class="clients-logo-list align-items-center">
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".2s">
                <a href="#">
                    <img src="assets/img/clients-image/img1.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".4s">
                <a href="#">
                    <img src="assets/img/clients-image/img2.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".6s">
                <a href="#">
                    <img src="assets/img/clients-image/img3.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".8s">
                <a href="#">
                    <img src="assets/img/clients-image/img4.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1s">
                <a href="#">
                    <img src="assets/img/clients-image/img5.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.2s">
                <a href="#">
                    <img src="assets/img/clients-image/img6.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.4s">
                <a href="#">
                    <img src="assets/img/clients-image/img7.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.6s">
                <a href="#">
                    <img src="assets/img/clients-image/img8.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.8s">
                <a href="#">
                    <img src="assets/img/clients-image/img9.png" alt="image">
                </a>
            </div>
        </div>
    </div>
</section> -->